import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { IIndividualLicense } from 'app/models/licenses/individual-license';
import { Observable } from 'rxjs';
import { ISearch } from 'app/models/licenses/search';
import { IStaff } from 'app/models/user/staff';

@Injectable({providedIn: 'root'})
export class IndividualLicenseService {
  private api: string = environment.privateApi + 'IndividualLicense/';
  private http = inject(HttpClient);

  getStaff(): Observable<IStaff[]>{
    return this.http.get<IStaff[]>(this.api + 'GetStaff');
  }

  searchLicenses(search: ISearch): Observable<IIndividualLicense[]>{
    return this.http.post<IIndividualLicense[]>(this.api + 'searchLicenses', search);
  }

  assignLicense(licenseId: number, staff: IStaff): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'AssignLicense/' + licenseId, staff);
  }

  approveLicense(licenseId: number, approved: boolean): Observable<IIndividualLicense>{
    return this.http.post<IIndividualLicense>(this.api + 'ApproveLicense/' + licenseId + '/' + approved, null);
  }

  createLicense(): Observable<IIndividualLicense>{
    return this.http.post<IIndividualLicense>(this.api + 'CreateLicense', null);
  }

  updateLicense(license: IIndividualLicense): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'UpdateLicense', license);
  }

  getLicenses(): Observable<IIndividualLicense[]>{
    return this.http.get<IIndividualLicense[]>(this.api + 'GetLicenses');
  }

  submitLicense(license: IIndividualLicense): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitLicense', license);
  }
}
